export function toCamelCase(snakeCaseStr: string): string {
  if (!snakeCaseStr) {
    return '';
  }

  return snakeCaseStr
    .toLowerCase()
    .replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace('_', ''));
}
